import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getSavedSimulations, toggleTimelineActive, switchClient, updateSentimentSettings } from '../../../actions/dataAction';
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTrash from '@fortawesome/fontawesome-free-solid/faTrashAlt';
import {Box, BoxButton} from '../../StyledComponents';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';


const styles = {
  propContainer: {
    width: 200,
    overflow: 'hidden',
    margin: '20px auto 0',
  },
  propToggleHeader: {
    margin: '20px auto 10px',
  },
};


const TrashBin = styled(FontAwesomeIcon)`
    margin-left:10px;
`;

/**
 * A more complex example, allowing the table height to be set, and key boolean properties to be toggled.
 */
class SentimentSettings extends Component {
  state = {
    fixedHeader: true,
    fixedFooter: true,
    stripedRows: false,
    showRowHover: true,
    selectable: true,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    height: '300px',
  };

  componentDidMount() {
      this.props.getSavedSimulations();
  }

  updateSentimentSettings(word, group) {
    if (!word) {
      return false;
    }
    let sentimentSettings = (this.props.user.userProfile && this.props.user.userProfile.sentimentSettings) ? this.props.user.userProfile.sentimentSettings : {};
    let wordGroup = sentimentSettings[group] || [];
    wordGroup.push(word);
    sentimentSettings[group] = wordGroup;
    this.props.updateSentimentSettings(sentimentSettings);
    this.setState({
      [group]: '',
    });
  }

  deleteWord(word, group) {
    let sentimentSettings = (this.props.user.userProfile && this.props.user.userProfile.sentimentSettings) ? this.props.user.userProfile.sentimentSettings : {};

    var array = sentimentSettings[group] || [];
    var search_term = word;

    for (var i=array.length-1; i>=0; i--) {
        if (array[i] === search_term) {
            array.splice(i, 1);
        }
    }
    sentimentSettings[group] = array;
    this.props.updateSentimentSettings(sentimentSettings);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    const sentimentSettings = this.props.user.userProfile && this.props.user.userProfile.sentimentSettings ? this.props.user.userProfile.sentimentSettings : {};
    const positive = sentimentSettings.positive || [];
    const negative = sentimentSettings.negative || [];

    return (
      <div>

            <h4>Positive</h4>
              {positive.map((word, index) => (
                <div key={index}>
                  <span>{word}</span><TrashBin icon={faTrash} onClick={(e)=> this.deleteWord(word, "positive")}/>
                </div>
              ))}

              <TextField value={this.state.positive} onChange={this.handleChange('positive')} />
              <FlatButton
                label="Save"
                primary={true}
                onClick={() => this.updateSentimentSettings(this.state.positive, "positive")}
                key="save"
              />

            <h4>Negative</h4>
              {negative.map((word, index) => (
                <div key={index}>
                  <span>{word}</span><TrashBin icon={faTrash} onClick={(e)=> this.deleteWord(word, "negative")}/>
                </div>
              ))}
              <TextField value={this.state.negative} onChange={this.handleChange('negative')} />
              <FlatButton
                label="Save"
                primary={true}
                onClick={() => this.updateSentimentSettings(this.state.negative, "negative")}
                key="save"
              />

      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        data: state.data
    };
}

export default connect(mapStateToProps, { getSavedSimulations, updateSentimentSettings })(SentimentSettings);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/SentimentSettings.js